/**
 * UI Store (Zustand)
 * Manages global UI state like modal visibility
 * Replaces Redux modalReducer
 */

import { create } from 'zustand';

/**
 * UI Store State interface
 */
interface UIStoreState {
  modalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  toggleModal: () => void;
}

/**
 * UI Store
 * Simple store for managing UI state that needs to be shared across components
 */
export const useUIStore = create<UIStoreState>((set) => ({
  // Modal state
  modalOpen: false,

  // Modal actions
  openModal: () => set({ modalOpen: true }),
  closeModal: () => set({ modalOpen: false }),
  toggleModal: () => set((state) => ({ modalOpen: !state.modalOpen })),
}));

// Selector hooks for specific state slices
export const useModalOpen = (): boolean => useUIStore((state) => state.modalOpen);

interface ModalActions {
  openModal: () => void;
  closeModal: () => void;
  toggleModal: () => void;
}

export const useModalActions = (): ModalActions => useUIStore((state) => ({
  openModal: state.openModal,
  closeModal: state.closeModal,
  toggleModal: state.toggleModal,
}));

export default useUIStore;
